var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',[_vm._v("© "+_vm._s(_vm.year)+" VUILD")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.baseUrl + "static/documents/EMARF_TOS_V200.pdf","target":"_blank"}},[_vm._v("Terms of service / 利用規約")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6b6203c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/Footer.vue
// module id = null
// module chunks = 